import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import { $hasEditVaultPermission } from '@/models/permissions.ts'

import { VaultCategoriesSearch } from './vault-categories-search'

export const VaultCategoriesTitle = () => {
  const hasEditVaultPermission = useUnit($hasEditVaultPermission)
  const handleCreateCategoryClick = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.VAULT_ADD_CATEGORY,
    })
  }, [])

  return (
    <div className="mb-2 flex h-[64px] items-center justify-between border-b pl-3">
      <p className="mr-2 text-xl font-medium">Vault</p>
      <div className="flex-1 pl-2">
        <VaultCategoriesSearch />
      </div>
      {hasEditVaultPermission && (
        <div className="flex items-center">
          <Tooltip content="Create New Category">
            <Button
              onClick={handleCreateCategoryClick}
              variant="ghost"
              className="text-text-default"
            >
              <PlusIcon className="h-6 w-6" />
            </Button>
          </Tooltip>
        </div>
      )}
    </div>
  )
}
